import { render, staticRenderFns } from "./ViewPostActions.vue?vue&type=template&id=03f73734&"
import script from "./ViewPostActions.vue?vue&type=script&lang=js&"
export * from "./ViewPostActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports